const SOCIAL_PROVIDERS_MAPPING = {
  googleOneTap: 'google'
}

const socialProviderFor = (provider) => {
  return SOCIAL_PROVIDERS_MAPPING[provider] || provider
}

export { SOCIAL_PROVIDERS_MAPPING, socialProviderFor }
